/**
 * True when keyboard focus is inside an editable text field (search input,
 * text-based filter input, a text input in an open drawer, or any
 * contenteditable). Used to guard keyboard shortcuts (e.g. Cmd/Ctrl+A, Esc) so
 * they keep their native behaviour while the user is typing.
 */
export const isEditableTextTarget = (element: Element | null): boolean => {
  if (!element) return false;

  const { tagName } = element;

  if (tagName === 'INPUT' || tagName === 'TEXTAREA') return true;

  return (element as HTMLElement).isContentEditable;
};
